export const toSplitThousand = (value, unit = '₽') =>
    value
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .concat(unit === '' ? '' : ` ${unit}`);

export const fromSplitThousand = (value) =>
    value?.toString().replace(/\d+/g, '');
